import TreatmentGroupCard from './TreatmentGroupCard';

export default TreatmentGroupCard;
